import { withAnalytics } from 'components/common/analytics';
import { PurchaseAccordion } from 'components/sign-up/components/purchase-accordion';
import { compose } from 'redux';

const enhance = compose(withAnalytics);
const PurchaseAccordionContainer = enhance(PurchaseAccordion);

export { PurchaseAccordionContainer };
